<template>
    <div class="tool_container" id="tool_container">
        <div class="panel_for_tool">
            <select class="select_for_tool" @change="chooseMaterial($event)">
                <option value="" hidden>请选择材料类型</option>
                <option v-for="(item, index) in selects" :key="index" :value="item.name">{{ item.title }}</option>
            </select>
        </div>
        <div class="content_for_tool">
            <div v-for="(item, index) in contents" :key="index" class="table_wraper">
                <div v-show="selects[index].isSelected">
                    <table class="table_for_tool" :id="item.name">
                        <thead>
                            <tr>
                                <th v-for="(th_item, th_index) in item.value[0]" :key="th_index">
                                    {{ th_item }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(tr_item, tr_index) in item.value.slice(1, item.value.length)" :key="tr_index">
                                <td v-for="(td_item, td_index) in tr_item" :key="td_index">{{ td_item }}</td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td :colspan="item.value[0].length" style="white-space: pre-wrap;">{{ item.tips }}</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "Material_Strength"
};
</script>

<script setup>
import { reactive } from "vue";
import { _getStrength } from "@/api/index";
import Toast from "@/utils/toast";

const selects = reactive([
    {
        title: "混凝土",
        name: "concrete",
        isSelected: false,
    },
    {
        title: "普通钢筋",
        name: "bar",
        isSelected: false,
    },
    {
        title: "钢材",
        name: "steel",
        isSelected: false,
    },
    // {
    //     title: "砌体",
    //     name: "masonry",
    //     isSelected: false,
    // },
]);
const contents = reactive([
    {
        title: "混凝土强度",
        name: "concrete_strength",
        value: [[], []],
        tips: '注：\n1、依据《混凝土结构设计标准》GB/T50010-2010(2024年版)编制。',
        isMerged: false,
    },
    {
        title: "钢筋强度",
        name: "bar_strength",
        value: [[], []],
        tips: '注：\n1、依据《混凝土结构设计标准》GB/T50010-2010(2024年版)编制。\n' +
            '2、对轴心受压构件，当采用HRB500、HRBF500钢筋时，fy\'应取400MPa。\n' +
            '3、横向钢筋的受拉强度设计值fyv按fy取值，但用作受剪、受扭、受冲切承载力计算时，其数值大于360MPa，应取360MPa。\n',
        isMerged: false,
    },
    {
        title: "钢材强度",
        name: "steel_strength",
        value: [[], []],
        tips: '注：\n1、依据《钢结构设计标准》(GB50017-2017)编制。',
        isMerged: true,
    },
    // {
    //     title: "砌体强度",
    //     name: "masonry_strength",
    //     value: [[], []],
    //     tips: '',
    //     isMerged: false,
    // },
]);
(function () {
    _getStrength().then(
        (res) => {
            if (res.data.message === "ok") {
                let data = res.data.data.strength;
                for (let i = 0; i < contents.length; i++) {
                    contents[i].value = data[i];
                }
            } else {
                Toast(res.data.message, 'tool_container', 50, 1000, true);
            }
        }
    ).catch(
        (err) => {
            Toast('网络错误，请稍后再试', 'tool_container', 50, 1000, true);
        }
    );
})();



function chooseMaterial(e) {
    let select = e.target;
    let i = select.selectedIndex; // selectedIndex代表的是你所选中项的index。
    let name = select.options[i].value;
    selects.forEach((item) => {
        if (item.name === name) {
            item.isSelected = true;
        } else {
            item.isSelected = false;
        }
    });
}

</script>



<style scoped>
/* 展示区内的样式～～～～～～～～～～～～～～～～～～～～～～～～～～～ */
.tool_container {
    background-color: white;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    opacity: 0.7;

}

/* panel区内的样式～～～～～～～～～～～～～～～～～～～～～～～～～～～ */
.panel_for_tool {
    height: 50px;
    width: 210px;
    padding: 0px 20px;
    border: 1px solid var(--secondary-color);
    border-radius: 25px;
    margin-top: 35px;
    margin-bottom: 35px;
    box-shadow: 6px 6px 3px rgba(0, 0, 0, 0.3), -4px -4px 4px rgba(194, 185, 185, 0.4);
    display: flex;
    justify-content: center;
}


.select_for_tool {
    width: 180px;
    height: 100%;
    border: none;
    outline: none;
    font-size: 16px;
    background-color: white;

}

/* content区内的样式～～～～～～～～～～～～～～～～～～～～～～～～～～～ */
.content_for_tool {
    width: 100%;
    /* position: relative; */
    height: calc(100%);
    overflow: auto;

}

.table_wraper {
    /* position: relative; */
    width: 100%;
    padding: 0 10px;
    /* overflow: scroll; */
}



table {
    border-collapse: collapse;
    margin: 0 auto 5px auto;
    text-align: center;
    position: relative;
}

/* thead {
    position: sticky;
    top: 0;
    left: 0;
    width: 100%;

} */

table td,
table th {
    border: 1.5px solid #858c94 !important;
    color: #666;
    height: 30px;
    padding: 0px 5px;
    vertical-align: middle;
    line-height: 30px;
}

td {
    padding-top: 3px !important;
}

table thead th {
    background-color: #62d4e0;
    width: 100px;
    padding: 5px 5px;
    /* background-clip: padding-box; */
}

table tr:nth-child(odd) {
    background: #fff;
}

table tr:nth-child(even) {
    background: #f3f3f3;
}

table tfoot td {
    text-align: left;
    font-size: 13px;
}





@media (orientation: portrait) and (max-width: 768px) {
    .tool_container {
        border-top: 1px solid #CCE8EB;
    }



    .content_for_tool {
        min-width: 100%;
    }
}
</style>
